import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const noNumbersAllowedValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const { value } = control;

  if (!value) return null;

  const containsNumberRegex = /\d/;

  if (containsNumberRegex.test(value)) {
    return { noNumbersAllowed: true };
  }

  return null;
};
